import { getStaticImageUrl } from "../config/gcs";

export const menu = [
  {
    text: "Home",
    onclick: "/",
    img: getStaticImageUrl("menupage/elf-trucking-service.webp"),
  },
  {
    text: "About Us ",
    onclick: "/about",
    img: getStaticImageUrl("menupage/elf-shipping-office.webp"),
  },
  {
    text: "Services ",
    onclick: "/services",
    img: getStaticImageUrl("menupage/elf-shipping-services.webp"),
  },

  {
    text: "News & Events ",
    onclick: "/news-and-events",
    img: getStaticImageUrl("menupage/elf-news-and-events.webp"),
  },
  {
    text: "Awards & recognitions ",
    onclick: "/awards-and-recognitions",
    img: getStaticImageUrl("menupage/elf-shipping-awards.webp"),
  },
  {
    text: "Gallery ",
    onclick: "/gallery",
    img: getStaticImageUrl("menupage/elf-gallery.webp"),
  },
  {
    text: "Contact Us ",
    onclick: "/contact",
    img: getStaticImageUrl("menupage/elf-contact.webp"),
  },
];
